import React from 'react';
import { motion } from 'framer-motion';

const LoadingState = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {[...Array(6)].map((_, i) => (
        <motion.div
          key={i}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: i * 0.1 }}
          className="relative overflow-hidden rounded-xl border bg-card p-4 hover:shadow-lg transition-shadow"
        >
          <div className="animate-pulse space-y-4">
            <div className="flex items-start justify-between">
              <div className="h-6 w-2/3 bg-muted rounded" />
            </div>
            
            <div className="space-y-2">
              <div className="h-4 w-full bg-muted rounded" />
              <div className="h-4 w-5/6 bg-muted rounded" />
              <div className="h-4 w-4/6 bg-muted rounded" />
            </div>

            <div className="flex gap-2">
              <div className="h-6 w-16 bg-muted rounded-full" />
              <div className="h-6 w-20 bg-muted rounded-full" />
            </div>

            <div className="flex items-center justify-between pt-2 border-t">
              <div className="flex items-center gap-2">
                <div className="h-8 w-8 bg-muted rounded-full" />
                <div className="h-4 w-24 bg-muted rounded" />
              </div>
              <div className="h-4 w-4 bg-muted rounded" />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};

export default LoadingState;